import React from "react";
import { useTranslation } from "react-i18next";
import { InputAutoresize } from "../../../common/components/form";
// import BackNext from "./BackNext.jsx";

// import WizardCheck from "./WizardCheck";
// const { MultipleCheck } = WizardCheck;

export default function WStep9GetInTouch(props) {
    const { t } = useTranslation();

    const { set, isCustom, variables, variables2block } = props;

    const items = isCustom ? [variables2block] : [{ variables }];

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStep9Header")}</h1>

                {items.map((item, index) => (
                    <Item key={index} {...item} set={(...args) => set(...args, item)} />
                ))}
            </div>
        </div>
    );
}

function Item(props) {
    const { t } = useTranslation();

    const {
        set,
        variables: { GetInTouch },
        allComplete,
    } = props;

    function onChange({ name, value }) {
        set({ GetInTouch: { ...GetInTouch, [name]: value } });
    }

    // const allowNext = MultipleCheck({ GetInTouch });

    return (
        <>
            <div className="margin-top-40">
                <p>{t("WizardWStep9Text")}</p>
            </div>

            <div className="margin-top-40">
                <InputAutoresize
                    name="text"
                    onChange={({ target: { name, value } }) => onChange({ name, value })}
                    value={GetInTouch?.text || ""}
                    placeholder={t("WizardWStep9TextInputPlaceholder")}
                />
            </div>

            <div className="margin-top-20">
                <InputAutoresize
                    type="email"
                    name="email"
                    onChange={({ target: { name, value } }) => onChange({ name, value })}
                    value={GetInTouch?.email || ""}
                    placeholder={t("WizardWStep9EmailInputPlaceholder")}
                />
            </div>

            <div className="margin-top-20">
                <InputAutoresize
                    name="button"
                    onChange={({ target: { name, value } }) => onChange({ name, value })}
                    value={GetInTouch?.button || ""}
                    placeholder={t("WizardWStep9ButtonInputPlaceholder")}
                />
            </div>
        </>
    );
}
